import { PRIMARY_COLOR, useGenerateColor } from "@/shared/composables/useGenerateColor.ts";
import { definePreset } from "@primeuix/themes";
import Aura from "@primeuix/themes/aura";

const HealthPreset = definePreset(Aura, {
  semantic: {
    primary: useGenerateColor(PRIMARY_COLOR),
  },
});

const primevuePreset = {
  ripple: true,
  theme: {
    preset: HealthPreset,
    options: {
      darkModeSelector: ".dark",
    },
  },
};

export default primevuePreset;
